import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg";
import { BaseURL, uniqueToken } from "../../api/DataApis";
// import "../Users/User.css"; // Assuming User.css has necessary styles

const ProfilePage = () => {
  document.title = "Profile Page";
  
  const [charger, setCharger] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const params = useParams();
  const ChargerID = params.cid;
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/chargers/details/${ChargerID}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res.data && res.data.data) {
        setCharger(res.data.data); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    } finally {
      setLoading(false); // Stop the loader after data fetch
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("charger........", charger);

  return (
    <>
   
        {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) :  (
        <div className="container my-5">
          <div className="card shadow-lg p-4">
            <h1 className="page-title text-center mb-4">Profile Page</h1>
            <div className="profile-header text-center">
              <img
                className="profile-image rounded-circle mb-3"
                src={charger[0]?.charger?.charger_image || image}
                alt="Charger"
              />
              <h5>{charger[0]?.charger?.charger_name}</h5>
            </div>
            
            <div className="profile-info mt-4">
              <h3 className="section-title">Profile Information</h3>
              <div className="row">
                <div className="col-md-6">
                  <p><span className="info-label">Email:</span> &nbsp; <b>Anupamjangir181@gmail.com</b></p>
                  <p><span className="info-label">UserName:</span>&nbsp; <b>Anupamjangir181@gmail.com</b></p>
                 </div>
                <div className="col-md-6">
                </div>
              </div>
            </div>
        
          
          </div>
        </div>
      )}
    </>
  );
};

export default ProfilePage;
